import { TitleCasePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { AppMainComponent } from '../../../../app.main.component';
import { ObjectNames, Severity } from '../../constants/constants';
import { PurchaseService } from '../purchase.service';

@Component({
  selector: 'app-purchase-type',
  templateUrl: './purchase-type.component.html',
  styleUrls: ['./purchase-type.component.scss']
})
export class PurchaseTypeComponent {

  allPurchaseStages = [];
  allPurchaseStatus = [];
  statusLists = [];
  displayEditPurchaseStatus = false;
  purchaseStageTemp = {
    "id": 0,
    "name": "",
    "createdUser": "",
    "isActive": true,
    "isDefault": false,
    "children": [],
    "statusChildren": []
  }
  purchaseStatusTemp = {
    "id": 0,
    "name": "",
    "isActive": true,
    "isDefault": false,
    "children": []
  }

  @Input() purchaseSubmoduleTypeId: any;
  @Input() purchaseSubmoduleConfig: any;
  @Input() allPurchaseSubmodule = [];
  sourceStatusList = [];
  targetStatusList = [];
  purchaseSubmoduleStageTemp: any = {};

  constructor(
    private service: ConfigurationService,private messageService: MessageService,private titlecasePipe: TitleCasePipe) { }


  eventCalled(subModuleRow) {
    if (subModuleRow?.isDefault) {
      if (subModuleRow?.stages?.length > 0) {
        subModuleRow.stages[0].isDefault = true;
      }
      this.allPurchaseSubmodule.forEach(element => {
        if (element.id != subModuleRow.id) {
          element.isDefault = false;
          if (element?.stages?.length > 0) {
            element.stages[0].isDefault = false;
          }
        }
      });
      this.updatePurchaseSubmodule(subModuleRow);
    }
  }

  updatePurchaseSubmodule(subModuleRowData) {
    this.allPurchaseSubmodule.forEach(element => {
      if (subModuleRowData?.id == element?.id) {
        // if(this.displayEditParentStatus) {
        //   element.statusTypeName = subModuleRowData?.statusTypeName;
        // } else if(this.displayEditChildStatus){
        //   element.name = subModuleRowData?.name;
        // }
        element.isActive = subModuleRowData?.isActive;
        element.isDefault = subModuleRowData?.isDefault;
        element.updatedDate = new Date().toISOString();
      }
    });

    this.purchaseSubmoduleConfig.configJSONValue = JSON.stringify(this.allPurchaseSubmodule);
    this.updateConfigurations();
  }

  updateConfigurations() {
    this.service.updateConfiguration(this.purchaseSubmoduleConfig).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Sub module updated successfully...' });
      this.loadConfigurations();
    }).catch(() => {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

  loadConfigurations() {
    this.service.getAllConfiguration().subscribe(configs => {
      this.purchaseSubmoduleConfig = configs.filter(s => s.name == ObjectNames.purchaseOrderConstants.Purchase_Submodule_Object && s.typeId == this.purchaseSubmoduleTypeId)[0];
      this.allPurchaseSubmodule = JSON.parse(this.purchaseSubmoduleConfig?.configurationDetails[0]?.configJSONValue);
      console.log(this.allPurchaseSubmodule)
    });
  }

  showEditStatus(parentData, childData) {
    // for (let a of s.children) {
    //   this.statusLists = this.statusLists.filter(element => element.name !== a.name);
    // }
    this.purchaseSubmoduleStageTemp = {
      'templateName': parentData?.name,
      'stageName': childData?.name,
      'templateId': parentData?.id,
      'stageId': childData?.id,
    };
    this.sourceStatusList = [];
    this.targetStatusList = [];
    childData.status.forEach((element, index) =>{
      if(element.isActive) {
        this.sourceStatusList.push(element);
      } else {
        this.targetStatusList.push(element);
      }
    });
    this.displayEditPurchaseStatus = true;
  }
  savePurchaseStatus() {
    this.targetStatusList.map(statusData => statusData.isActive = false);
    this.sourceStatusList.map(statusData => statusData.isActive = true);
    this.purchaseSubmoduleConfig.configJSONValue = JSON.stringify(this.allPurchaseSubmodule);
    this.updateConfigurations();
    this.displayEditPurchaseStatus = false;
  }

}
